<template>
  <!-- <div id="login">
    <section>
      <div :class="{ 'signup-form': !showLoginForm }" class="col2">
        <form v-if="showLoginForm" @submit.prevent>
          <h1>Welcome Back</h1>
          <div>
            <label for="email1">Email</label>
            <input
              v-model.trim="loginForm.email"
              type="text"
              placeholder="you@email.com"
              id="email1"
            />
          </div>
          <div>
            <label for="password1">Password</label>
            <input
              v-model.trim="loginForm.password"
              type="password"
              placeholder="******"
              id="password1"
            />
          </div>
          <button @click="login()" class="button">Log In</button>
          <div class="extras">
            <button @click="toggleForm()">Create an Account</button>
          </div>
        </form>
        <form v-else @submit.prevent>
          <h1>Get Started</h1>
          <div>
            <label for="name">Name</label>
            <input
              v-model.trim="signupForm.name"
              type="text"
              placeholder="your name"
              id="name"
            />
          </div>
          <div>
            <label for="email2">Email</label>
            <input
              v-model.trim="signupForm.email"
              type="text"
              placeholder="you@email.com"
              id="email2"
            />
          </div>
          <div>
            <label for="password2">Password</label>
            <input
              v-model.trim="signupForm.password"
              type="password"
              placeholder="min 6 characters"
              id="password2"
            />
          </div>
          <button @click="signup()" class="button">Sign Up</button>
          <div class="extras">
            <button @click="toggleForm()">Back to Log In</button>
          </div>
        </form>
      </div>
    </section>
  </div> -->
  <v-container id="login">
    <v-form v-if="showLoginForm" @submit.prevent>
      <h1>Welcome Back!</h1>
      <v-text-field
        v-model.trim="loginForm.email"
        type="text"
        placeholder="you@email.com"
        label="Email"
      />
      <v-text-field
        v-model.trim="loginForm.password"
        type="password"
        placeholder="******"
        label="Password"
      />
      <v-btn type="submit" @click="login()" class="button">Log In</v-btn>
      <div class="extras">
        <v-btn @click="toggleForm()">
          <span>Create an Account</span>
        </v-btn>
      </div>
    </v-form>
    <v-form v-else @submit.prevent>
      <h1>Get Started</h1>
      <v-text-field
        v-model.trim="signupForm.name"
        type="text"
        label="your name"
      />
      <v-text-field v-model.trim="signupForm.email" type="text" label="Email" />
      <v-text-field
        v-model.trim="signupForm.password"
        type="password"
        label="Password"
        :rules="rules"
      />
      <v-btn @click="signup()" class="button">Sign Up</v-btn>
      <div class="extras">
        <v-btn @click="toggleForm()">
          <span>Back to Log In</span>
        </v-btn>
      </div>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      signupForm: {
        name: "",
        email: "",
        password: ""
      },
      showLoginForm: true,
      rules: [value => (value && value.length >= 6) || "Min 6 characters"]
    };
  },
  methods: {
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login() {
      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password
      });
    },
    signup() {
      this.$store.dispatch("signup", {
        email: this.signupForm.email,
        password: this.signupForm.password,
        name: this.signupForm.name
      });
    }
  }
};
</script>
